var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"d-block d-md-flex"},[_c('AppAside'),_c('div',{staticClass:"ps-5 page_content grow"},[_c('Stats',{attrs:{"data_loaded":_vm.data_loaded,"stats":_vm.stats}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }